import React, { Component } from "react";
import { withRouter } from "./withRouter";
import ReactMap, { Source, Layer } from "react-map-gl";
import { Box, Stack, Typography,ToggleButtonGroup,ToggleButton,Autocomplete,TextField } from "@mui/material";
import NZ2026HomeTooltip from "./NZ2026HomeTooltip"
import NZ2026SeatCompTooltip from "./NZ2026SeatCompTooltip"
import TooltipInternalMainMap from "./TooltipInternalMainMap"
import TooltipInternalHeatMap from "./TooltipInternalHeatMap"
const MAPBOX_TOKEN =
  "pk.eyJ1IjoibXppZW1pYW4iLCJhIjoiY2xhOXdpc2h5MDI1MzNxbG1wdzcxOWNlZSJ9.Km0c9-jUUlcBs6ByXYbYZA";


const MAP_STYLE = "mapbox://styles/mapbox/light-v11"; 

const possibleAreas = [
  { area_name: "Buitenland", area_id: "GM0998" },
  { area_name: "Almere", area_id: "GM0034" },
  { area_name: "Zeewolde", area_id: "GM0050" },
  { area_name: "Ameland", area_id: "GM0060" },
  { area_name: "Harlingen", area_id: "GM0072" },
  { area_name: "Schiermonnikoog", area_id: "GM0088" },
  { area_name: "Terschelling", area_id: "GM0093" },
  { area_name: "Vlieland", area_id: "GM0096" },
  { area_name: "Kampen", area_id: "GM0166" },
  { area_name: "Noordoostpolder", area_id: "GM0171" },
  { area_name: "Urk", area_id: "GM0184" },
  { area_name: "Elburg", area_id: "GM0230" },
  { area_name: "Ermelo", area_id: "GM0233" },
  { area_name: "Harderwijk", area_id: "GM0243" },
  { area_name: "Nijkerk", area_id: "GM0267" },
  { area_name: "Oldebroek", area_id: "GM0269" },
  { area_name: "Putten", area_id: "GM0273" },
  { area_name: "Nunspeet", area_id: "GM0302" },
  { area_name: "Dronten", area_id: "GM0303" },
  { area_name: "Bunschoten", area_id: "GM0313" },
  { area_name: "Eemnes", area_id: "GM0317" },
  { area_name: "Amsterdam", area_id: "GM0363" },
  { area_name: "Bergen (NH.)", area_id: "GM0373" },
  { area_name: "Beverwijk", area_id: "GM0375" },
  { area_name: "Blaricum", area_id: "GM0376" },
  { area_name: "Bloemendaal", area_id: "GM0377" },
  { area_name: "Castricum", area_id: "GM0383" },
  { area_name: "Diemen", area_id: "GM0384" },
  { area_name: "Edam-Volendam", area_id: "GM0385" },
  { area_name: "Enkhuizen", area_id: "GM0388" },
  { area_name: "Heemskerk", area_id: "GM0396" },
  { area_name: "Den Helder", area_id: "GM0400" },
  { area_name: "Hoorn", area_id: "GM0405" },
  { area_name: "Huizen", area_id: "GM0406" },
  { area_name: "Medemblik", area_id: "GM0420" },
  { area_name: "Schagen", area_id: "GM0441" },
  { area_name: "Texel", area_id: "GM0448" },
  { area_name: "Velsen", area_id: "GM0453" },
  { area_name: "Zandvoort", area_id: "GM0473" },
  { area_name: "Drechterland", area_id: "GM0498" },
  { area_name: "Dordrecht", area_id: "GM0505" },
  { area_name: "'s-Gravenhage", area_id: "GM0518" },
  { area_name: "Stede Broec", area_id: "GM0532" },
  { area_name: "Katwijk", area_id: "GM0537" },
  { area_name: "Noordwijk", area_id: "GM0575" },
  { area_name: "Rotterdam", area_id: "GM0599" },
  { area_name: "Wassenaar", area_id: "GM0629" },
  { area_name: "Borsele", area_id: "GM0654" },
  { area_name: "Goes", area_id: "GM0664" },
  { area_name: "Hulst", area_id: "GM0677" },
  { area_name: "Kapelle", area_id: "GM0678" },
  { area_name: "Middelburg (Z.)", area_id: "GM0687" },
  { area_name: "Reimerswaal", area_id: "GM0703" },
  { area_name: "Terneuzen", area_id: "GM0715" },
  { area_name: "Tholen", area_id: "GM0716" },
  { area_name: "Veere", area_id: "GM0717" },
  { area_name: "Vlissingen", area_id: "GM0718" },
  { area_name: "Steenbergen", area_id: "GM0851" },
  { area_name: "Waterland", area_id: "GM0852" },
  { area_name: "Lelystad", area_id: "GM0995" },
  { area_name: "Koggenland", area_id: "GM1598" },
  { area_name: "Schouwen-Duiveland", area_id: "GM1676" },
  { area_name: "Noord-Beveland", area_id: "GM1695" },
  { area_name: "Steenwijkerland", area_id: "GM1708" },
  { area_name: "Moerdijk", area_id: "GM1709" },
  { area_name: "Sluis", area_id: "GM1714" },
  { area_name: "Westland", area_id: "GM1783" },
  { area_name: "Oldambt", area_id: "GM1895" },
  { area_name: "Zwartewaterland", area_id: "GM1896" },
  { area_name: "Súdwest-Fryslân", area_id: "GM1900" },
  { area_name: "Hollands Kroon", area_id: "GM1911" },
  { area_name: "Goeree-Overflakkee", area_id: "GM1924" },
  { area_name: "Nissewaard", area_id: "GM1930" },
  { area_name: "De Fryske Marren", area_id: "GM1940" },
  { area_name: "Gooise Meren", area_id: "GM1942" },
  { area_name: "Waadhoeke", area_id: "GM1949" },
  { area_name: "Hoeksche Waard", area_id: "GM1963" },
  { area_name: "Het Hogeland", area_id: "GM1966" },
  { area_name: "Westerkwartier", area_id: "GM1969" },
  { area_name: "Noardeast-Fryslân", area_id: "GM1970" },
  { area_name: "Eemsdelta", area_id: "GM1979" },
  { area_name: "Voorne aan Zee", area_id: "GM1992" },
  { area_name: "Groningen", area_id: "GM0014" },
  { area_name: "Stadskanaal", area_id: "GM0037" },
  { area_name: "Veendam", area_id: "GM0047" },
  { area_name: "Achtkarspelen", area_id: "GM0059" },
  { area_name: "Heerenveen", area_id: "GM0074" },
  { area_name: "Leeuwarden", area_id: "GM0080" },
  { area_name: "Ooststellingwerf", area_id: "GM0085" },
  { area_name: "Opsterland", area_id: "GM0086" },
  { area_name: "Smallingerland", area_id: "GM0090" },
  { area_name: "Weststellingwerf", area_id: "GM0098" },
  { area_name: "Assen", area_id: "GM0106" },
  { area_name: "Coevorden", area_id: "GM0109" },
  { area_name: "Emmen", area_id: "GM0114" },
  { area_name: "Hoogeveen", area_id: "GM0118" },
  { area_name: "Meppel", area_id: "GM0119" },
  { area_name: "Almelo", area_id: "GM0141" },
  { area_name: "Borne", area_id: "GM0147" },
  { area_name: "Dalfsen", area_id: "GM0148" },
  { area_name: "Deventer", area_id: "GM0150" },
  { area_name: "Enschede", area_id: "GM0153" },
  { area_name: "Haaksbergen", area_id: "GM0158" },
  { area_name: "Hardenberg", area_id: "GM0160" },
  { area_name: "Hellendoorn", area_id: "GM0163" },
  { area_name: "Hengelo (O.)", area_id: "GM0164" },
  { area_name: "Losser", area_id: "GM0168" },
  { area_name: "Oldenzaal", area_id: "GM0173" },
  { area_name: "Ommen", area_id: "GM0175" },
  { area_name: "Raalte", area_id: "GM0177" },
  { area_name: "Staphorst", area_id: "GM0180" },
  { area_name: "Tubbergen", area_id: "GM0183" },
  { area_name: "Wierden", area_id: "GM0189" },
  { area_name: "Zwolle", area_id: "GM0193" },
  { area_name: "Aalten", area_id: "GM0197" },
  { area_name: "Apeldoorn", area_id: "GM0200" },
  { area_name: "Arnhem", area_id: "GM0202" },
  { area_name: "Barneveld", area_id: "GM0203" },
  { area_name: "Beuningen", area_id: "GM0209" },
  { area_name: "Brummen", area_id: "GM0213" },
  { area_name: "Buren", area_id: "GM0214" },
  { area_name: "Culemborg", area_id: "GM0216" },
  { area_name: "Doesburg", area_id: "GM0221" },
  { area_name: "Doetinchem", area_id: "GM0222" },
  { area_name: "Druten", area_id: "GM0225" },
  { area_name: "Duiven", area_id: "GM0226" },
  { area_name: "Ede", area_id: "GM0228" },
  { area_name: "Epe", area_id: "GM0232" },
  { area_name: "Hattem", area_id: "GM0244" },
  { area_name: "Heerde", area_id: "GM0246" },
  { area_name: "Heumen", area_id: "GM0252" },
  { area_name: "Lochem", area_id: "GM0262" },
  { area_name: "Maasdriel", area_id: "GM0263" },
  { area_name: "Nijmegen", area_id: "GM0268" },
  { area_name: "Renkum", area_id: "GM0274" },
  { area_name: "Rheden", area_id: "GM0275" },
  { area_name: "Rozendaal", area_id: "GM0277" },
  { area_name: "Scherpenzeel", area_id: "GM0279" },
  { area_name: "Tiel", area_id: "GM0281" },
  { area_name: "Voorst", area_id: "GM0285" },
  { area_name: "Wageningen", area_id: "GM0289" },
  { area_name: "Westervoort", area_id: "GM0293" },
  { area_name: "Winterswijk", area_id: "GM0294" },
  { area_name: "Wijchen", area_id: "GM0296" },
  { area_name: "Zaltbommel", area_id: "GM0297" },
  { area_name: "Zevenaar", area_id: "GM0299" },
  { area_name: "Zutphen", area_id: "GM0301" },
  { area_name: "Amersfoort", area_id: "GM0307" },
  { area_name: "Baarn", area_id: "GM0308" },
  { area_name: "De Bilt", area_id: "GM0310" },
  { area_name: "Bunnik", area_id: "GM0312" },
  { area_name: "Houten", area_id: "GM0321" },
  { area_name: "Leusden", area_id: "GM0327" },
  { area_name: "Lopik", area_id: "GM0331" },
  { area_name: "Montfoort", area_id: "GM0335" },
  { area_name: "Renswoude", area_id: "GM0339" },
  { area_name: "Rhenen", area_id: "GM0340" },
  { area_name: "Soest", area_id: "GM0342" },
  { area_name: "Utrecht", area_id: "GM0344" },
  { area_name: "Veenendaal", area_id: "GM0345" },
  { area_name: "Woudenberg", area_id: "GM0351" },
  { area_name: "Wijk bij Duurstede", area_id: "GM0352" },
  { area_name: "IJsselstein", area_id: "GM0353" },
  { area_name: "Zeist", area_id: "GM0355" },
  { area_name: "Nieuwegein", area_id: "GM0356" },
  { area_name: "Aalsmeer", area_id: "GM0358" },
  { area_name: "Alkmaar", area_id: "GM0361" },
  { area_name: "Amstelveen", area_id: "GM0362" },
  { area_name: "Haarlem", area_id: "GM0392" },
  { area_name: "Haarlemmermeer", area_id: "GM0394" },
  { area_name: "Heemstede", area_id: "GM0397" },
  { area_name: "Heiloo", area_id: "GM0399" },
  { area_name: "Hilversum", area_id: "GM0402" },
  { area_name: "Landsmeer", area_id: "GM0415" },
  { area_name: "Laren (NH.)", area_id: "GM0417" },
  { area_name: "Oostzaan", area_id: "GM0431" },
  { area_name: "Opmeer", area_id: "GM0432" },
  { area_name: "Ouder-Amstel", area_id: "GM0437" },
  { area_name: "Purmerend", area_id: "GM0439" },
  { area_name: "Uitgeest", area_id: "GM0450" },
  { area_name: "Uithoorn", area_id: "GM0451" },
  { area_name: "Zaanstad", area_id: "GM0479" },
  { area_name: "Alblasserdam", area_id: "GM0482" },
  { area_name: "Alphen aan den Rijn", area_id: "GM0484" },
  { area_name: "Barendrecht", area_id: "GM0489" },
  { area_name: "Capelle aan den IJssel", area_id: "GM0502" },
  { area_name: "Delft", area_id: "GM0503" },
  { area_name: "Gorinchem", area_id: "GM0512" },
  { area_name: "Gouda", area_id: "GM0513" },
  { area_name: "Hardinxveld-Giessendam", area_id: "GM0523" },
  { area_name: "Hendrik-Ido-Ambacht", area_id: "GM0531" },
  { area_name: "Hillegom", area_id: "GM0534" },
  { area_name: "Krimpen aan den IJssel", area_id: "GM0542" },
  { area_name: "Leiden", area_id: "GM0546" },
  { area_name: "Leiderdorp", area_id: "GM0547" },
  { area_name: "Lisse", area_id: "GM0553" },
  { area_name: "Maassluis", area_id: "GM0556" },
  { area_name: "Nieuwkoop", area_id: "GM0569" },
  { area_name: "Oegstgeest", area_id: "GM0579" },
  { area_name: "Oudewater", area_id: "GM0589" },
  { area_name: "Papendrecht", area_id: "GM0590" },
  { area_name: "Ridderkerk", area_id: "GM0597" },
  { area_name: "Rijswijk (ZH.)", area_id: "GM0603" },
  { area_name: "Schiedam", area_id: "GM0606" },
  { area_name: "Sliedrecht", area_id: "GM0610" },
  { area_name: "Albrandswaard", area_id: "GM0613" },
  { area_name: "Vlaardingen", area_id: "GM0622" },
  { area_name: "Voorschoten", area_id: "GM0626" },
  { area_name: "Waddinxveen", area_id: "GM0627" },
  { area_name: "Woerden", area_id: "GM0632" },
  { area_name: "Zoetermeer", area_id: "GM0637" },
  { area_name: "Zoeterwoude", area_id: "GM0638" },
  { area_name: "Zwijndrecht", area_id: "GM0642" },
  { area_name: "West Maas en Waal", area_id: "GM0668" },
  { area_name: "De Ronde Venen", area_id: "GM0736" },
  { area_name: "Tytsjerksteradiel", area_id: "GM0737" },
  { area_name: "Asten", area_id: "GM0743" },
  { area_name: "Baarle-Nassau", area_id: "GM0744" },
  { area_name: "Bergen op Zoom", area_id: "GM0748" },
  { area_name: "Best", area_id: "GM0753" },
  { area_name: "Boekel", area_id: "GM0755" },
  { area_name: "Boxtel", area_id: "GM0757" },
  { area_name: "Breda", area_id: "GM0758" },
  { area_name: "Deurne", area_id: "GM0762" },
  { area_name: "Pekela", area_id: "GM0765" },
  { area_name: "Dongen", area_id: "GM0766" },
  { area_name: "Eersel", area_id: "GM0770" },
  { area_name: "Eindhoven", area_id: "GM0772" },
  { area_name: "Etten-Leur", area_id: "GM0777" },
  { area_name: "Geertruidenberg", area_id: "GM0779" },
  { area_name: "Gilze en Rijen", area_id: "GM0784" },
  { area_name: "Goirle", area_id: "GM0785" },
  { area_name: "Helmond", area_id: "GM0794" },
  { area_name: "'s-Hertogenbosch", area_id: "GM0796" },
  { area_name: "Heusden", area_id: "GM0797" },
  { area_name: "Hilvarenbeek", area_id: "GM0798" },
  { area_name: "Loon op Zand", area_id: "GM0809" },
  { area_name: "Nuenen, Gerwen en Nederwetten", area_id: "GM0820" },
  { area_name: "Oirschot", area_id: "GM0823" },
  { area_name: "Oisterwijk", area_id: "GM0824" },
  { area_name: "Oosterhout", area_id: "GM0826" },
  { area_name: "Oss", area_id: "GM0828" },
  { area_name: "Rucphen", area_id: "GM0840" },
  { area_name: "Sint-Michielsgestel", area_id: "GM0845" },
  { area_name: "Someren", area_id: "GM0847" },
  { area_name: "Son en Breugel", area_id: "GM0848" },
  { area_name: "Tilburg", area_id: "GM0855" },
  { area_name: "Valkenswaard", area_id: "GM0858" },
  { area_name: "Veldhoven", area_id: "GM0861" },
  { area_name: "Vught", area_id: "GM0865" },
  { area_name: "Waalre", area_id: "GM0866" },
  { area_name: "Waalwijk", area_id: "GM0867" },
  { area_name: "Woensdrecht", area_id: "GM0873" },
  { area_name: "Zundert", area_id: "GM0879" },
  { area_name: "Wormerland", area_id: "GM0880" },
  { area_name: "Landgraaf", area_id: "GM0882" },
  { area_name: "Beek (L.)", area_id: "GM0888" },
  { area_name: "Beesel", area_id: "GM0889" },
  { area_name: "Bergen (L.)", area_id: "GM0893" },
  { area_name: "Brunssum", area_id: "GM0899" },
  { area_name: "Gennep", area_id: "GM0907" },
  { area_name: "Heerlen", area_id: "GM0917" },
  { area_name: "Kerkrade", area_id: "GM0928" },
  { area_name: "Maastricht", area_id: "GM0935" },
  { area_name: "Meerssen", area_id: "GM0938" },
  { area_name: "Mook en Middelaar", area_id: "GM0944" },
  { area_name: "Nederweert", area_id: "GM0946" },
  { area_name: "Roermond", area_id: "GM0957" },
  { area_name: "Simpelveld", area_id: "GM0965" },
  { area_name: "Stein (L.)", area_id: "GM0971" },
  { area_name: "Vaals", area_id: "GM0981" },
  { area_name: "Venlo", area_id: "GM0983" },
  { area_name: "Venray", area_id: "GM0984" },
  { area_name: "Voerendaal", area_id: "GM0986" },
  { area_name: "Weert", area_id: "GM0988" },
  { area_name: "Valkenburg aan de Geul", area_id: "GM0994" },
  { area_name: "Horst aan de Maas", area_id: "GM1507" },
  { area_name: "Oude IJsselstreek", area_id: "GM1509" },
  { area_name: "Teylingen", area_id: "GM1525" },
  { area_name: "Utrechtse Heuvelrug", area_id: "GM1581" },
  { area_name: "Oost Gelre", area_id: "GM1586" },
  { area_name: "Lansingerland", area_id: "GM1621" },
  { area_name: "Leudal", area_id: "GM1640" },
  { area_name: "Maasgouw", area_id: "GM1641" },
  { area_name: "Gemert-Bakel", area_id: "GM1652" },
  { area_name: "Halderberge", area_id: "GM1655" },
  { area_name: "Heeze-Leende", area_id: "GM1658" },
  { area_name: "Laarbeek", area_id: "GM1659" },
  { area_name: "Reusel-De Mierden", area_id: "GM1667" },
  { area_name: "Roerdalen", area_id: "GM1669" },
  { area_name: "Roosendaal", area_id: "GM1674" },
  { area_name: "Aa en Hunze", area_id: "GM1680" },
  { area_name: "Borger-Odoorn", area_id: "GM1681" },
  { area_name: "De Wolden", area_id: "GM1690" },
  { area_name: "Wijdemeren", area_id: "GM1696" },
  { area_name: "Noordenveld", area_id: "GM1698" },
  { area_name: "Twenterand", area_id: "GM1700" },
  { area_name: "Westerveld", area_id: "GM1701" },
  { area_name: "Lingewaard", area_id: "GM1705" },
  { area_name: "Cranendonck", area_id: "GM1706" },
  { area_name: "Echt-Susteren", area_id: "GM1711" },
  { area_name: "Drimmelen", area_id: "GM1719" },
  { area_name: "Bernheze", area_id: "GM1721" },
  { area_name: "Alphen-Chaam", area_id: "GM1723" },
  { area_name: "Bergeijk", area_id: "GM1724" },
  { area_name: "Bladel", area_id: "GM1728" },
  { area_name: "Gulpen-Wittem", area_id: "GM1729" },
  { area_name: "Tynaarlo", area_id: "GM1730" },
  { area_name: "Midden-Drenthe", area_id: "GM1731" },
  { area_name: "Overbetuwe", area_id: "GM1734" },
  { area_name: "Hof van Twente", area_id: "GM1735" },
  { area_name: "Neder-Betuwe", area_id: "GM1740" },
  { area_name: "Rijssen-Holten", area_id: "GM1742" },
  { area_name: "Geldrop-Mierlo", area_id: "GM1771" },
  { area_name: "Olst-Wijhe", area_id: "GM1773" },
  { area_name: "Dinkelland", area_id: "GM1774" },
  { area_name: "Midden-Delfland", area_id: "GM1842" },
  { area_name: "Berkelland", area_id: "GM1859" },
  { area_name: "Bronckhorst", area_id: "GM1876" },
  { area_name: "Sittard-Geleen", area_id: "GM1883" },
  { area_name: "Kaag en Braassem", area_id: "GM1884" },
  { area_name: "Dantumadiel", area_id: "GM1888" },
  { area_name: "Zuidplas", area_id: "GM1892" },
  { area_name: "Peel en Maas", area_id: "GM1894" },
  { area_name: "Bodegraven-Reeuwijk", area_id: "GM1901" },
  { area_name: "Eijsden-Margraten", area_id: "GM1903" },
  { area_name: "Stichtse Vecht", area_id: "GM1904" },
  { area_name: "Leidschendam-Voorburg", area_id: "GM1916" },
  { area_name: "Pijnacker-Nootdorp", area_id: "GM1926" },
  { area_name: "Krimpenerwaard", area_id: "GM1931" },
  { area_name: "Berg en Dal", area_id: "GM1945" },
  { area_name: "Meierijstad", area_id: "GM1948" },
  { area_name: "Westerwolde", area_id: "GM1950" },
  { area_name: "Midden-Groningen", area_id: "GM1952" },
  { area_name: "Beekdaelen", area_id: "GM1954" },
  { area_name: "Montferland", area_id: "GM1955" },
  { area_name: "Altena", area_id: "GM1959" },
  { area_name: "West Betuwe", area_id: "GM1960" },
  { area_name: "Vijfheerenlanden", area_id: "GM1961" },
  { area_name: "Molenlanden", area_id: "GM1978" },
  { area_name: "Dijk en Waard", area_id: "GM1980" },
  { area_name: "Land van Cuijk", area_id: "GM1982" },
  { area_name: "Maashorst", area_id: "GM1991" }
];

class MapComponent extends Component {


 

  render() {
    const { geoLevel, styledGeo, geoData, hoverInfo,polLevel } = this.props;
    const { styleLoaded, selectedFeature } = this.props;


    return (
      <div style={{ height: "100%", width: "100%" }}>
        {selectedFeature?.name && (
          <div
            style={{
              position: "absolute",
              top: 12,
              left: 12,
              background: "rgba(255,255,255,0.95)",
              padding: "6px 10px",
              borderRadius: 6,
              fontFamily: "Inter, system-ui, sans-serif",
              fontSize: 13,
              boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <strong>Selected:</strong> {selectedFeature.name}
            <button
              onClick={() => this.setState({ selectedFeature: null })}
              style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                fontSize: 16,
                lineHeight: 1,
                color: "#666",
                marginLeft: 6,
              }}
              aria-label="Clear selection"
              title="Clear selection"
            >
              
            </button>
          </div>
        )}

        <ReactMap
          ref={this.props.mapRef}
            initialViewState={{
                    bounds: [
                    [3.3, 50.7],  // SW (south-west)
[7.2, 53.6],  // NE (north-east)
                    ],
                    fitBoundsOptions: { padding: 40 }, // optional, gives margin
                }}
          style={{ width: "100%", height: "100%" }}
          projection={{ name: "mercator" }}
          mapStyle={MAP_STYLE}
          mapboxAccessToken={MAPBOX_TOKEN}
          interactiveLayerIds={["geo-fill"]}
            renderWorldCopies={true} // allow the map to repeat horizontally
          onClick={this.props.onMapClick}
          onMouseMove={this.props.onMouseMove}
          onLoad={this.onStyleLoad}
          viewState={this.props.viewState ? this.props.viewState : null}
        >
          {styleLoaded && (styledGeo || geoData)?.features && (
            <Source id="geo" type="geojson" data={styledGeo || geoData}>
              <Layer
                id="geo-fill"
                type="fill"
                paint={{
                  "fill-color": ["coalesce", ["get", "fillColor"], "#ffffff"],
                  "fill-opacity": ["case", ["has", "fillColor"], 0.75, 0],
                }}
              />
              <Layer
                id="geo-outline"
                type="line"
                paint={{
                  "line-color": "#111",
                  "line-width": 0.25,
                  "line-opacity": ["case", ["has", "fillColor"], 0.025, 0],
                }}
              />
              {selectedFeature?.level && (
                <Layer
                  id="geo-hover"
                  type="line"
                  paint={{
                    "line-color": "#ffffff",
                    "line-width": 2,
                  }}
                  filter={[
                    "==",
                    ["get",  "area_id"],
                    hoverInfo?.props?.["area_id"] || "",
                  ]}
                />
              )}
              <Layer
                id="geo-selected-halo"
                type="line"
                paint={{
                  "line-color": "#ffffff",
                  "line-width": 4,
                }}
                filter={
                  selectedFeature?.level === geoLevel && selectedFeature?.value
                    ? ["==", ["get", selectedFeature.key], selectedFeature.value]
                    : ["==", ["get", "__none__"], "__none__"]
                }
              />
              <Layer
                id="geo-selected"
                type="line"
                paint={{
                  "line-color": "#1976d2",
                  "line-width": 2,
                }}
                filter={
                  selectedFeature?.level === geoLevel && selectedFeature?.value
                    ? ["==", ["get", selectedFeature.key], selectedFeature.value]
                    : ["==", ["get", "__none__"], "__none__"]
                }
              />
            </Source>
          )}
          {hoverInfo && (
            this.props.tooltip === "home" ? (
                <NZ2026HomeTooltip
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                geoLevel={geoLevel}
                
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
            ) : this.props.tooltip === "seatcomp" ? (

                <NZ2026SeatCompTooltip
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
              
              
            ) : this.props.tooltip ==="InternalMain" ?(
                <TooltipInternalMainMap
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
              
            ) : this.props.tooltip === "InternalHeat" ? (

                              <TooltipInternalHeatMap
                hoverInfo={hoverInfo}
                geoData={geoData}
                styledGeo={styledGeo}
                chosenView = {this.props.chosenView}
                chosenParty = {this.props.chosenParty}
                geoLevel={geoLevel}
                tooltip_pastcomp={this.props.tooltip_pastcomp}
                />
            ): (null)
            )}

   {!this.props.smallMap &&(
           <Box
        sx={{
          position: "absolute",
          top: 16,
          left: 16,
          zIndex: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: 2,
          px: 2,
          paddingTop: 0.5,
          paddingBottom: 1.5,
          pointerEvents: "auto",
          boxShadow: 2
        }}
      >

     

        <Stack direction="row" sx={{
           display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        //flex: 1, 
        py:0,px:0,
        mb: 0.5}}>
        <Typography
          variant="caption"
          sx={{ display: "block",  color: "text.secondary" }}
        >
          Map Level
        </Typography>
        
              </Stack>

        <ToggleButtonGroup
          value={geoLevel}
          exclusive
          onChange={(e, newLevel) => {
            if (newLevel) this.props.onGeoLevelChange(newLevel);
          }}
          size="small"
        >
          <ToggleButton value="geementen">Gemeente</ToggleButton>
          <ToggleButton value="buurt">Buurt</ToggleButton>

        </ToggleButtonGroup>


      </Box>
   )}

      {!this.props.smallMap &&(
           <Box
        sx={{
          position: "absolute",
          bottom: 20,
          left: 16,
          zIndex: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: 2,
          px: 2,
          paddingTop: 0.5,
          paddingBottom: 1.5,
          pointerEvents: "auto",
          boxShadow: 2
        }}
      >

     

        <Stack direction="row" sx={{
           display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        //flex: 1, 
        py:0,px:0,
        mb: 0.5}}>
        <Typography
          variant="caption"
          sx={{ display: "block",  color: "text.secondary" }}
        >
          Electoral data:
        </Typography>
        
              </Stack>

        <ToggleButtonGroup
          value={polLevel}
          exclusive
          onChange={(e, newLevel) => {
            if (newLevel) this.props.onPolLevelChange(newLevel);
          }}
          size="small"
        >
          <ToggleButton value="past">2025 election</ToggleButton>
          <ToggleButton value="GE">General Election VI</ToggleButton>
          <ToggleButton value="LE">Municipal Election VI</ToggleButton>

        </ToggleButtonGroup>


      </Box>
   )}
   {!this.props.smallMap &&(

      <Box
        sx={{
          position: "absolute",
          top: 16,
          right: 16,
          zIndex: 2,
          backgroundColor: "rgba(255,255,255,0.95)",
          borderRadius: 2,
          px: 2,
          paddingTop: 0.5,
          paddingBottom: 1.5,
          pointerEvents: "auto",
          boxShadow: 2
        }}
      >

        <Stack direction="row" sx={{
           display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        //flex: 1, 
        py:0,px:0,
        mb: 0.5}}>
        <Typography
          variant="caption"
          sx={{ display: "block",  color: "text.secondary" }}
        >
          Choose a gemeenten to zoom in
        </Typography>
        
              </Stack>

         <Autocomplete
            disablePortal
              options={possibleAreas} // the array you passed up
              getOptionLabel={(option) => option.area_name}
            sx={{ width: "100%", mt:1.5, height:1 }}
            value={selectedFeature}
            renderInput={(params) => <TextField {...params} label="Find an area:"
                                                            size="small"             // <-- makes the input smaller
                                                            sx={{
                                                              "& .MuiInputBase-root": { height: 40 },  // adjust overall input height
                                                              "& .MuiOutlinedInput-input": { padding: "4px 8px" } // adjust inner text padding
                                                            }} />}
            onChange={(event, newValue) => {

             if (newValue === null) {
                this.props.resetView({LevelToResetTo:"geementen"})

               }else{
                  this.props.handleselectedFeatureChange(
                    {area_id:newValue?.area_id,area_name:newValue?.area_name}
                  );
                }

            }
          }
          />


      </Box>
        )}



        </ReactMap>
      </div>
    );
  }
}

export default withRouter(MapComponent);
